<template>
  <div>
    <v-text-field
      @keyup.enter="search"
      :hide-details="!searchError"
      autofocus
      type="number"
      v-model="phone"
      placeholder="請輸入畜主手機"
      :append-icon="phone ? 'mdi-close-circle' : ''"
      prepend-inner-icon="mdi-magnify"
      @click:append="clear()"
      :error-messages="searchError"
      :error="searchError !== ''"
      outlined
    ></v-text-field>
    <v-btn
      depressed
      block
      large
      dark
      :color="$classStyle.mainColor"
      @click="search"
      :class="{ 'mt-2': !searchError }"
      >搜尋</v-btn
    >
  </div>
</template>
<script>
export default {
  props: ["clinic"],
  data: () => ({
    phone: "",
    searchError: ""
  }),
  watch: {
    async phone() {
      this.checkExist();
    }
  },
  methods: {
    async checkExist() {
      if (this.phone && String(this.phone).length > 9) {
        let response = await this.$ajax.get(
          `${this.$config.apiUrl}/${this.clinic}/users/${this.phone}`
        );
        this.searchError = response.data !== null ? "" : "查無使用者";
      } else if (!this.phone) {
        this.searchError = "";
      }
    },
    clear() {
      this.phone = "";
      this.searchError = "";
    },
    async search() {
      await this.checkExist();
      if (this.phone && !this.searchError && String(this.phone).length > 9) {
        this.$emit("search", this.phone);
      }
    }
  }
};
</script>
